import { ErrorsNavigationContextProvider } from 'contexts/ErrorsNavigationContext/ErrorsNavigationContextProvider';
import { WebEDIMessageErrorBanner } from 'components/WebEDI/WebEDIMessageErrorBanner/WebEDIMessageErrorBanner';
import { DisplayModes } from 'components/DataTable/Types';
import { WebEDIErrorsServiceSingleton } from 'services/webediErrors';
import { MessageFieldErrorModal } from 'components/WebEDI/MessageFieldErrorModal/MessageFieldErrorModal';
import { WebEDIError } from 'services/webediErrors/types';
import { PaymentReconciliationBanner } from '../PaymentReconciliationBanner/PaymentReconciliationBanner';
import { MessageV2DTO } from 'support/types';

type PaymentReconciliationTopBannerProps = {
  blockingError: MessageV2DTO['blocking_error'];
  hasPendingItems: boolean;
  isFilteringPendingOnly: boolean;
  onTogglePendingFilter: () => void;
};

export const PaymentReconciliationTopBanner = ({
  blockingError,
  hasPendingItems,
  isFilteringPendingOnly,
  onTogglePendingFilter,
}: PaymentReconciliationTopBannerProps) => {
  if (blockingError) {
    return (
      <ErrorsNavigationContextProvider<WebEDIError>
        service={WebEDIErrorsServiceSingleton}
        ErrorModalComponent={MessageFieldErrorModal}
      >
        <WebEDIMessageErrorBanner mode={DisplayModes.view} blockingError={blockingError} />
      </ErrorsNavigationContextProvider>
    );
  }

  if (hasPendingItems) {
    return <PaymentReconciliationBanner onCheckboxClick={onTogglePendingFilter} checked={isFilteringPendingOnly} />;
  }

  return null;
};
